/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ContentManagementDeleteContentByFileNameResponse } from './ContentManagementDeleteContentByFileNameResponse';

export type ContentManagementDeleteContentByFileNameResponseApiRespoonse = {
    data?: ContentManagementDeleteContentByFileNameResponse;
    status?: ContentManagementDeleteContentByFileNameResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ContentManagementDeleteContentByFileNameResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

